"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_inputs_1 = require("@hotelplan/components.common.inputs");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const AutocompleteContext_1 = require("./AutocompleteContext");
const TriggerInputWrapper = styled_components_1.default.div({
    position: 'relative',
});
const TriggerInput = (0, styled_components_1.default)(components_common_inputs_1.BaseInput)(({ theme }) => (0, util_theme_sxc_1.sx2CssTheme)(theme, {
    '.icon': {
        variant: ['icons.md', 'icons.lg'],
    },
    input: {
        pr: [null, '10px'],
    },
}));
// eslint-disable-next-line react/display-name
const AutocompleteTriggerInput = (0, react_1.forwardRef)((props, ref) => {
    const { onInteract, onFocus, onClick, displayValue, caption, className = '' } = props, otherProps = __rest(props, ["onInteract", "onFocus", "onClick", "displayValue", "caption", "className"]);
    const ctx = (0, AutocompleteContext_1.useAutocompleteContext)();
    const displayedValue = typeof displayValue === 'function'
        ? displayValue(ctx.selectedItems)
        : displayValue;
    return (react_1.default.createElement(TriggerInputWrapper, null,
        react_1.default.createElement(TriggerInput, Object.assign({ className: `trigger-input ${className}`, hideLabel: true, ref: ref, onChange: noop_1.default, onFocus: () => {
                onFocus === null || onFocus === void 0 ? void 0 : onFocus();
                onInteract === null || onInteract === void 0 ? void 0 : onInteract();
            }, onClick: () => {
                onClick === null || onClick === void 0 ? void 0 : onClick();
                onInteract === null || onInteract === void 0 ? void 0 : onInteract();
            }, readOnly: true, value: displayedValue, "data-id": "trigger" }, otherProps), caption)));
});
AutocompleteTriggerInput.displayName = 'AutocompleteTriggerInput';
exports.default = AutocompleteTriggerInput;
//# sourceMappingURL=AutocompleteTriggerInput.js.map